import "./Inter-Medium-normal";
import "./Inter-SemiBold-normal";
import "./Inter-Bold-normal";
import "./Inter-ExtraBold-normal";
